export default "__VITE_ASSET__M6_g_4X6__"